import { getTenantFromDomain } from '../../../utils';
const tenant = getTenantFromDomain();
const fmgDefaults = [
      // Domestic defaults
          {
            name: 'preferred_unit_id',
            displayName: 'Default Buy UOM',
            tooltip: 'Provide the Default Buy Unit of Measure (UOM) of the Packer.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'unit',
            group: 'Domestic',
          },
          {
            name: 'default_buy_incoterms',
            displayName: 'Default Buy Incoterms',
            tooltip: 'Provide the default buy incoterms of the Packer',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'incoterms',
            group: 'Domestic',
          },
          {
            name: 'default_buy_currency',
            displayName: 'Default Buy Currency',
            tooltip: 'Provide the default buy currency of the Packer',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'currency',
            group: 'Domestic',
          },
          // APMEA Export defaults
          {
            name: 'apmea_default_preferred_unit_id',
            displayName: 'Default Buy UOM',
            tooltip: 'Provide the Default Buy Unit of Measure (UOM) for APMEA Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'unit',
            group: 'APMEA Export',
          },
          {
            name: 'apmea_default_buy_incoterms',
            displayName: 'Default Buy Incoterms',
            tooltip: 'Provide the default buy incoterms for APMEA Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'incoterms',
            group: 'APMEA Export',
          },
          {
            name: 'apmea_default_buy_currency',
            displayName: 'Default Buy Currency',
            tooltip: 'Provide the default buy currency for APMEA Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'currency',
            group: 'APMEA Export',
          },
          // USA Export defaults
          {
            name: 'usa_default_preferred_unit_id',
            displayName: 'Default Buy UOM',
            tooltip: 'Provide the Default Buy Unit of Measure (UOM) for USA Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'unit',
            group: 'USA Export',
          },
          {
            name: 'usa_default_buy_incoterms',
            displayName: 'Default Buy Incoterms',
            tooltip: 'Provide the default buy incoterms for USA Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'incoterms',
            group: 'USA Export',
          },
          {
            name: 'usa_default_buy_currency',
            displayName: 'Default Buy Currency',
            tooltip: 'Provide the default buy currency for USA Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'currency',
            group: 'USA Export',
          },
          // China Export defaults
          {
            name: 'china_default_preferred_unit_id',
            displayName: 'Default Buy UOM',
            tooltip: 'Provide the Default Buy Unit of Measure (UOM) for China Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'unit',
            group: 'China Export',
          },
          {
            name: 'china_default_buy_incoterms',
            displayName: 'Default Buy Incoterms',
            tooltip: 'Provide the default buy incoterms for China Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'incoterms',
            group: 'China Export',
          },
          {
            name: 'china_default_buy_currency',
            displayName: 'Default Buy Currency',
            tooltip: 'Provide the default buy currency for China Export.',
            dataType: 'reference',
            referenceType: 'select',
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'currency',
            group: 'China Export',
          },
          // NEW: Domestic default Container/Load Combo
          {
            name: 'domestic_container_load_combo',
            displayName: 'Default Container/Load Combo',
            tooltip: 'Select the default Container/Load Combo for Domestic.',
            dataType: 'reference',
            referenceType: 'select',
            // Use the same source as the AU/NZ Order form Container/Load Combo dropdown:
            // if that uses load_size, use:
            // referenceEntityType: 'load_size',
            // if instead it uses form_fields with a subtype, adjust accordingly:
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'container',
            group: 'Container Load Combo Domestic',
          },
          // NEW: Export default Container/Load Combo
          {
            name: 'export_container_load_combo',
            displayName: 'Export Container/Load Combo',
            tooltip: 'Select the default Container/Load Combo for Export.',
            dataType: 'reference',
            referenceType: 'select',
            // Again, use the same entity as the AU/NZ order form dropdown:
            // referenceEntityType: 'load_size',
            // or, if needed:
            referenceEntityType: 'form_fields',
            referenceEntitySubType: 'container',
            group: 'Container Load Combo Export',
          },
      ]
      const nonFmgDefaults  = [
        {
        name: 'preferred_unit_id',
        displayName: 'Default Buy UOM',
        tooltip: 'Provide the Default Buy Unit of Measure (UOM) of the Packer.',
        dataType: 'reference',
        referenceType: 'select',
        referenceEntityType: 'unit',
      },
      {
        name: 'default_buy_incoterms',
        displayName: 'Default Buy Incoterms',
        tooltip: 'Provide the default buy incoterms of the Packer',
        dataType: 'reference',
        referenceType: 'select',
        referenceEntityType: 'form_fields',
        referenceEntitySubType: 'incoterms',
      },
      {
        name: 'default_buy_currency',
        displayName: 'Default Buy Currency',
        tooltip: 'Provide the default buy currency of the Packer',
        dataType: 'reference',
        referenceType: 'select',
        referenceEntityType: 'form_fields',
        referenceEntitySubType: 'currency',
      },
    ]
const tenantSpecificDefaults =  tenant === 'fmg' ? fmgDefaults : nonFmgDefaults;
const schema = [
  {
    name: 'packer',
    displayName: 'Packer',
    nested: false,
    systemIdField: 'id',
    displayIdField: 'name',
    tabGroup: { key: 'suppliers', label: 'Suppliers' },
    deletable: true,
    path: '/packers',
    autoUid: true,
    fields: [
      {
        name: 'id',
        displayName: 'UID',
        tooltip: 'Provide the Unique ID to create the Packer',
        dataType: 'shorttext',
        required: false,
        systemIdentifier: false,
      },
      {
        name: 'name',
        displayName: 'Name',
        tooltip: 'Provide the name of the Packer',
        dataType: 'shorttext',
        required: true,
        systemIdentifier: false,
        hidden: false,
      },
      {
        name: 'company_name',
        displayName: 'Company Name',
        tooltip: 'Provide the company name of the Packer',
        dataType: 'shorttext',
        required: false,
        systemIdentifier: false,
        hideList: true,
      },
      {
        name: 'purchasing_office',
        displayName: 'Purchasing Office',
        tooltip: 'Select the Purchasing Office associcated of the Packers',
        dataType: 'reference',
        referenceType: 'multi-select',
        referenceEntityType: 'form_fields',
        referenceEntitySubType: 'business_office',
      },
      // Inject tenant-based defaults here
      ...tenantSpecificDefaults,
      {
        name: 'product_type',
        displayName: 'Product Type',
        tooltip: 'Select the Product type of the Packer, either Beef or Pork.',
        dataType: 'reference',
        referenceType: 'select',
        referenceEntityType: 'form_fields',
        referenceEntitySubType: 'product_types',
        required: true,
      },
      {
        name: 'packer_plant_ids',
        displayName: 'Establishments',
        tooltip: 'Select the Establishments of the Packers',
        dataType: 'reference',
        referenceType: 'multi-select',
        referenceEntityType: 'packer_plant',
        required: true,
      },
      {
        name: 'organisation_ids',
        displayName: 'Organisation',
        tooltip: 'Select an organisation of the Packer',
        dataType: 'reference',
        referenceType: 'multi-select',
        referenceEntityType: 'organisation',
        required: true,
      },
      {
        name: 'tax_rate',
        displayName: 'Tax rate',
        tooltip: 'Provide the Tax rate for the Establishment',
        dataType: 'float',
        required: false,
      },
      {
        name: 'tax_code',
        displayName: 'Tax code',
        tooltip: 'Provide the Tax code for the Establishment',
        dataType: 'float',
        required: false,
      },
      {
        name: 'address',
        displayName: 'Address',
        dataType: 'reference',
        referenceType: 'nested',
        referenceEntityType: 'address_port',
      },
      {
        name: 'latitude',
        displayName: 'Latitude',
        dataType: 'shorttext',
        hideList: true,
      },
      {
        name: 'longitude',
        displayName: 'Longitude',
        dataType: 'shorttext',
        hideList: true,
      },
      {
        name: 'timezone',
        displayName: 'Timezone',
        dataType: 'shorttext',
        hideList: true,
      },
    ],
  },
];
export default schema;
